module.exports = __webpack_public_path__ + "img/dt-logo-symbol.155a1912.svg";